
import { default as axios } from "axios";
// Add a request interceptor
axios.interceptors.request.use(function (config) {
    // Do something before request is sent 
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Do something with response data
    //console.log(window.location.pathname !="/relogin", 'response.data.body');
   
   if(response.data.body && response.data.body.message ==='redirect'){
    window.location.href = "/api/login?redirect=true&redirect_url="+window.location.pathname;
    return false;

   }
    return response;
  }, function (error) {
    
    const errorResponse = {
      data: {
        statusCode: 500,
        body: {
          message: error.message
        }
      }
     
    }
    return Promise.resolve(errorResponse);
    
   
  });

export default axios;